<div class="app-mian-header">
  <div class="header-inner">
    <div class="menu-toggle" (click)="toggelSidebar()">
      <img src="assets/images/icons/minimize-sidebar.svg" alt="">
    </div>
    <div class="logo-mobile">
      <img src="./assets/images/logos/logo-sm.svg">
    </div>
    <div class="header-actions">
      <a class="btn btn-lang" (click)="changeLanguage()">
        {{ 'general.language' | translate }}
      </a>
      <!-- <span class="text-orange text-nowrap ml-4">Vr. <b>{{version}}</b></span> -->

      <p class="orange-color font-14 ml-2 text-nowrap"
        *ngIf="actionsPermissions?.currentRestaurantAction?.attendancefeature">
        {{"auth.Clock-In" | translate}}:
        <span class="fontSemiBold">
          {{actionsPermissions.currentRestaurantAction?.lastClockIn | date:'d MMM, y - h:mm a'}}
        </span>
      </p>
    </div>
    <div class="header-part-right">
      <button matRipple class="header-btn no-bg" *ngIf="actionsPermissions?.canShowZatcaNotification" (click)="zatcaReports()"
        [class.loading]="zatcaLoaing"
        [disabled]="zatcaLoaing">
        <div class="icon-badge">
          <span class="status-badge red">
            {{actionsPermissions.zatcaNotification.faildCount}}
          </span>
          <img class="m-0" src="./assets/images/invoices.png" alt="" [matTooltip]="'general.Zakat Invoices' | translate">
        </div>
      </button>
      <a class="header-btn d-flex" [routerLink]="['/admin/orderList/blend']" routerLinkActive="active"
        *ngIf="actionsPermissions?.deliveryPermissions?.hasDeliveryOrders">
        <div class="d-flex m-auto">
          <span class="m-auto">{{ actionsPermissions?.deliveryPermissions?.buttonName }}
            ({{actionsPermissions?.deliveryPermissions?.deliverOrdersCount}})</span>
        </div>
      </a>
      <!-- TAKEAWAY & PICKUP -->
      <a class="header-btn d-flex" [routerLink]="['/admin/orderList/takeaway-pickup/placeorder']"
        routerLinkActive="active" *ngIf="actionsPermissions?.canQuickCreateOrder">
        <div class="d-flex m-auto">
          <img src="./assets/images/icons/takeaway.svg" alt="">
          <span class="m-auto">{{ 'placeOrder.New Order' | translate }} +</span>
        </div>
      </a>
      <div class="elementor-widget-container">
        <div class="notification-btn dropdown-container" appDropDown>
          <span (click)="openNotificationPanel()">
            <span class="notification-count">{{ notificationsResult.unSeenNotificationsCount }}</span>
            <img src="./assets/images/icons/notifications-icon.svg"
              [ngClass]="{swing: notificationsResult.unSeenNotificationsCount}">
          </span>
          <div class="notification-panel dropdown-inner-menu">
            <div class="notification-header">
              <h3>{{ 'general.Notification' | translate }}</h3>
            </div>

            <div class="notifications-wrapper">
              <div *ngIf='notifLoading' class="dataLoading py-5">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
              </div>
              <div [hidden]='notifLoading'>
                <div class="no-data text-center px-2 py-5" *ngIf="!notificationsList.length">
                  {{ 'general.You have no notifications' | translate }}!
                </div>
                <div class="notification-list" *ngIf="notificationsList.length" infiniteScroll [scrollWindow]="false"
                  [infiniteScrollDistance]="2" [infiniteScrollThrottle]="pageCount" (scrolled)="getNextPage()">
                  <div *ngFor="let notif of notificationsList" [ngClass]="{new: !notif.isSeen}"
                    (click)="notificationMenu = false">

                    <ng-container [ngSwitch]="notif.notificationType">
                      <a *ngSwitchCase="'RestaurantStuff'" [routerLink]="['/admin/profile']">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'Payment'" [routerLink]="['/admin/settings/payment']">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'Restaurant'"
                        [routerLink]="['/admin/restaurants/profile', notif.notificationObjectId]">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'Reservition'" [routerLink]="['/admin/reservations/floor']"
                        [queryParams]="{ reservationId: notif.notificationObjectId, restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'Order'"
                        [routerLink]="['/admin/reservations/floor/place-order', notif.data[1], notif.data[0]]"
                        [queryParams]="{ wOrderId: notif.notificationObjectId }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'KdsOrder'"
                        [routerLink]="['/admin/orders', notif.data[0], notif.notificationObjectId]"
                        [queryParams]="{ kitchenId: notif.data[2] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'Checkout'"
                        [routerLink]="['/admin/reservations/floor/place-order', notif.data[1], notif.data[0]]"
                        [queryParams]="{ wOrderId: notif.notificationObjectId, wCheckout: true }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'Reviews'" [routerLink]="['/admin/guestsReviews']"
                        [queryParams]="{ reviewsId: notif.notificationObjectId, restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>

                      <!-- parchaseRequest -->
                      <a *ngSwitchCase="'WareHouseReceiverPurchaseOrder'"
                        [routerLink]="['/admin/warehouses/parchaseRequest']"
                        [queryParams]="{ status: 'ReceivedRequests', restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'WareHouseSenderAcceptPurchaseOrder'"
                        [routerLink]="['/admin/warehouses/parchaseRequest']"
                        [queryParams]="{ status: 'SentRequests', restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'WareHouseSenderRejectPurchaseOrder'"
                        [routerLink]="['/admin/warehouses/parchaseRequest']"
                        [queryParams]="{ status: 'SentRequests', restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>

                      <!-- needStock -->
                      <a *ngSwitchCase="'WareHouseReceiverNeedStok'" [routerLink]="['/admin/warehouses/needStock']"
                        [queryParams]="{ status: 'ReceivedRequests', restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'WareHouseSenderAcceptNeedStok'" [routerLink]="['/admin/warehouses/needStock']"
                        [queryParams]="{ status: 'SentRequests', restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'WareHouseSenderRejectNeedStok'" [routerLink]="['/admin/warehouses/needStock']"
                        [queryParams]="{ status: 'SentRequests', restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>

                      <!-- sendStock -->
                      <a *ngSwitchCase="'WareHouseReceiverSendStok'" [routerLink]="['/admin/warehouses/sendStock']"
                        [queryParams]="{ status: 'ReceivedRequests', restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'WareHouseSenderAcceptSendStok'" [routerLink]="['/admin/warehouses/sendStock']"
                        [queryParams]="{ status: 'SentRequests', restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'WareHouseSenderRejectSendStok'" [routerLink]="['/admin/warehouses/sendStock']"
                        [queryParams]="{ status: 'SentRequests', restaurantId: notif.data[0] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>

                      <!-- Deliverect failed Order -->
                      <a *ngSwitchCase="'DeliverectFailedOrder'" [routerLink]="['/admin/orderList/blend']"
                        [queryParams]="{ status: 'Failed', restaurantId: notif.data[1] }">
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>

                      <a *ngSwitchDefault>
                        <ng-container [ngTemplateOutlet]="notifContent"
                          [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                    </ng-container>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="elementor-widget-container">
        <div *ngIf="currentUser" class="userAccount dropdown-container m-0" id="userAccountDrop" appDropDown>
          <div class="dropdown-toggler d-flex align-items-center">
            <div class="profile-image">
              <img *ngIf="currentUser.profilePicture" [src]="currentUser.profilePicture"
                (error)="currentUser.profilePicture = ''" />
              <span *ngIf="!currentUser.profilePicture" [innerHTML]="currentUser.fullName | shortName"></span>
            </div>
            <div class="user-name">
              <span class="mr-2"> {{ 'general.Hello' | translate }}, {{currentUser.fullName}}</span>
            </div>
          </div>

          <div class="custom-dropdown-menu dropdown-inner-menu">
            <ul>
              <!-- [routerLink]="['profile']" -->
              <li><a [routerLink]="['profile']">
                  <svg width="14" height="17" viewBox="0 0 14 17">
                    <path id="my-profile-icon"
                      d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z"
                      fill="#999999" />
                  </svg>{{ 'general.View Profile' | translate }}
                </a></li>
              <li hidden><a [routerLink]="['changepassword']">
                  <svg width="14" height="17" viewBox="0 0 14 17">
                    <path id="my-profile-icon"
                      d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z"
                      fill="#999999" />
                  </svg>{{ 'general.Update password' | translate }}
                </a></li>
              <li>
                <a (click)="logout()">
                  <svg width="17.001" height="17.006" viewBox="0 0 17.001 17.006">
                    <path id="logout-icon"
                      d="M6223.19,12103h-13.4a1.815,1.815,0,0,1-1.8-1.808v-13.383a1.815,1.815,0,0,1,1.811-1.808h13.4a1.817,1.817,0,0,1,1.792,1.808v4.146l-1.659-1.559v-2.74h-13.687v13.575h13.687v-2.625l1.659-1.461v4.165a1.766,1.766,0,0,1-.529,1.267,1.69,1.69,0,0,1-1.123.43C6223.3,12103.006,6223.243,12103,6223.19,12103Zm-4.514-5.039,2.691-2.688h-9.562v-1.54h9.562l-2.691-2.691,1.167-1.169,4.52,4.629-4.52,4.629Z"
                      transform="translate(-6208 -12086)" fill="#999" />
                  </svg>{{ 'general.Logout' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #notifContent let-notif="notif">
  <p class="title">{{notif.notificationText}}</p><span class="date">
    {{notif.notificationDate | timeAgo}}
    <!-- date:'d MMM, y (h:mm a)' -->
  </span>
</ng-template>
